<template>
  <!-- <div class="dashboard" style="font-size: 0.8rem; margin-top:100px!important">
        <div class="w-100">
            <b-alert style="display: flex; justify-content: space-between" v-if="wppStatus === 'Conectado'"
                variant="success" show>
                <span>WhatsApp conectado!</span>
                <span style="font-size: 0.8rem; color: #666">
                    {{ me.name }} ({{ me.phone }})
                </span>
            </b-alert>

            <b-alert v-if="wppStatus === 'Desconectado'" variant="warning" show>
                Aguardando conexão com o WhatsApp!
            </b-alert>

            <b-alert v-if="wppStatus === 'Aguardando leitura do QRCODE'" variant="warning" show>
                Aguardando leitura do QRCODE
            </b-alert>

            <b-alert v-if="wppStatus === 'STARTING'" variant="danger" show>
                Iniciando WhatsApp...
            </b-alert>
        </div>

        <div class="mb-3">
            <button class="btn btn-sm btn-primary" @click="getQrCodePrimary"
                v-if="['Desconectado'].includes(wppStatus)">
                QR Code
            </button>
        </div>
        <div class="d-flex justify-content-between mb-2 w-100" style="border-bottom: 3px solid #666; color: #666">
            <h3 style="font-size: 1rem">{{ title }}</h3>
        </div>
        <div>
            <ListMarketing :body="body" @changeBody="(data) => (body = data)" :nextPage="nextPage"
                @clearBody="clearBody()" v-if="pageName === 'listCampanha'" />

            <NewMarketing :body="body" :nextPage="nextPage" v-if="pageName === 'newCampanha'" />

            <SelectCustomer :body="body" :nextPage="nextPage" v-if="pageName === 'selectClientes'" />

            <PreviewMarketing :body="body" :nextPage="nextPage" v-if="pageName === 'previewMarketing'" />

            <div class="w-100">
                <img v-if="qrCode" :src="`data:image/png;base64,${qrCode}`" />
            </div>
        </div>
    </div> -->
  <div class="marketing-maintenance-alert">
    <div class="marketing-maintenance-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94z"
        />
      </svg>
    </div>

    <div class="marketing-maintenance-content">
      <div class="marketing-maintenance-header">
        <h3>Função de Marketing temporariamente indisponível</h3>

        <span class="marketing-maintenance-badge"> Em manutenção </span>
      </div>

      <p>
        A função de <strong>Marketing</strong> está em manutenção para adequação
        às recentes atualizações realizadas pelo WhatsApp.
      </p>

      <p>
        Nossa equipe já está trabalhando nos ajustes necessários, mas, no
        momento, ainda não temos uma previsão para o restabelecimento da
        funcionalidade.
      </p>

      <div class="marketing-maintenance-info">
        <strong>Importante:</strong>
        as demais funcionalidades do CRM continuarão disponíveis e funcionando
        normalmente durante esse período.
      </div>

      <p class="marketing-maintenance-footer">
        Assim que a função de Marketing estiver novamente disponível,
        informaremos pelo sistema. Agradecemos a compreensão.
      </p>
    </div>
  </div>
</template>

<script>
// import NewMarketing from "./components/newMarketing.vue";
// import ListMarketing from "./components/listMarketing.vue";
// import SelectCustomer from "./components/selectCustomer.vue";
// import PreviewMarketing from "./components/previewMarketing.vue";
import { ServiceWhatsaApp } from "../../services/ServiceWhatsaApp";

export default {
  components: {
    // NewMarketing,
    // ListMarketing,
    // SelectCustomer,
    // PreviewMarketing,
  },
  data() {
    return {
      title: "Marketing",
      pageName: "listCampanha",
      contacts: [],
      umvalor: 1,
      wppStatus: null,
      me: {
        phone: "",
        name: "",
      },
      qrCode: "",
      body: {
        id: null,
        name: "",
        message: "",
        data: "",
        hour: "",
        contacts: [],
      },
    };
  },
  methods: {
    async helthCheck() {
      try {
        const status = await ServiceWhatsaApp.healthCheck("marketing");
        this.wppStatus = status;

        if (status === "Conectado") {
          this.getMeSession();
        } else if (status === "Aguardando leitura do QRCODE") {
          this.getQrCodePrimary();
        } else if (status === "Iniciando serviços") {
          this.getQrCodePrimary();
        } else if (status === "STARTING") {
          this.wppStatus = "Iniciando WhatsApp...";
        } else {
          this.wppStatus = "Desconectado";
        }
      } catch (error) {
        this.wppStatus = "Aguardando conexão com o WhatsApp!";
      }
    },
    async getMeSession() {
      try {
        const data = await ServiceWhatsaApp.me("marketing");
        this.me = {
          phone: data.id.replace("@c.us", "").substring(2),
          name: data.pushName,
        };
      } catch (error) {
        this.wppStatus = "Aguardando conexão com o WhatsApp!";
      }
    },
    async getQrCodePrimary() {
      this.$bvToast.toast("Gerando QR Code", {
        title: "Aguarde",
        variant: "info",
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
      const qrcode = await ServiceWhatsaApp.getQrCodePrimary("marketing");

      this.qrCode = qrcode;

      this.$bvToast.toast("QR Code gerado com sucesso", {
        title: "Sucesso",
        variant: "success",
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    async disconnect() {
      this.$toast.open({
        message: "Desconectando...",
        type: "info",
      });

      await ServiceWhatsaApp.disconnect("marketing");

      this.$toast.open({
        message: "Desconectado com sucesso",
        type: "success",
      });
    },
    nextPage(page) {
      this.pageName = page;
    },
    clearBody() {
      this.body = {
        id: null,
        name: "",
        message: "",
        data: "",
        hour: "",
        contacts: [],
      };
    },
  },
  created() {
    // this.helthCheck();
  },
  watch: {
    pageName() {
      const titles = {
        listCampanha: "Campanhas",
        newCampanha: "Nova Campanha",
        selectClientes: "Selecionar Clientes",
      };

      this.title = titles[this.pageName];
    },
  },
};
</script>

<style scoped>
p {
  margin: 0px;
  padding: 0px;
  font-size: 14px;
}

.dashboard {
  width: 80%;
  margin-top: 35px;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .dashboard {
    width: 90%;
    margin-left: 30px;
  }
}

@media screen and (max-width: 700px) {
  .dashboard {
    width: 80%;
  }
}

.marketing-maintenance-alert {
  margin-top: 100px !important;
  display: flex;
  gap: 16px;
  padding: 20px;
  border: 1px solid #fde68a;
  border-left: 4px solid #f59e0b;
  border-radius: 12px;
  background: linear-gradient(135deg, #fffbeb 0%, #ffffff 100%);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.marketing-maintenance-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #fef3c7;
  color: #d97706;
}

.marketing-maintenance-content {
  flex: 1;
  min-width: 0;
}

.marketing-maintenance-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.marketing-maintenance-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.4;
}

.marketing-maintenance-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 999px;
  background: #fef3c7;
  color: #b45309;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.marketing-maintenance-content p {
  margin: 0 0 10px;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.65;
}

.marketing-maintenance-info {
  margin: 14px 0;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fff7ed;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.marketing-maintenance-info strong {
  color: #c2410c;
}

.marketing-maintenance-footer {
  margin-bottom: 0 !important;
}

@media (max-width: 600px) {
  .marketing-maintenance-alert {
    padding: 16px;
  }

  .marketing-maintenance-icon {
    width: 42px;
    height: 42px;
  }

  .marketing-maintenance-header {
    align-items: flex-start;
  }

  .marketing-maintenance-header h3 {
    font-size: 16px;
  }
}
</style>
